import axios from "axios";
export const SpriteJson = ()=> axios.get("./sprite.json").then(res =>res.data)
export const SpriteJson1 = ()=> axios.get("../sprite.json").then(res =>res.data)
